'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useDefaultAppContexts } from '@hivebrite/frontoffice-default-app-contexts';
import { useScrollTop } from '@hivebrite/react-hooks';
import { Box } from '@design-system/box';
import { useI18n } from '@design-system/i18n';
import { DefaultLink } from '@design-system/link';
import { AttachedFiles } from './AttachedFiles';
import { ContentWrapper } from './ContentWrapper';
import { CoverPicture } from './CoverPicture';
import { Header } from './Header';
import { Layout } from './Layout';
import { PublicationText } from './PublicationText';
import { RelatedNews } from './RelatedNews';
import { useNewsShowContext } from '../context/NewsShowContext';
export const Main = ({ children }) => {
    const { data: { news, relatedNews }, } = useNewsShowContext();
    const { content, id, rssUrl } = news;
    const { s__ } = useI18n();
    const { currentUser } = useDefaultAppContexts();
    // Related News only displayed on PO
    const showRelatedNews = !currentUser;
    useScrollTop([id]);
    const withRelatedNews = showRelatedNews && relatedNews && relatedNews.length > 0;
    return (_jsxs(_Fragment, { children: [_jsxs(Layout, { pb: withRelatedNews ? '6' : '120px', children: [_jsx(CoverPicture, {}), _jsxs(ContentWrapper, { children: [_jsx(Header, {}), _jsx(PublicationText, { content: content }), rssUrl && (_jsx(Box, { mb: 4, mt: 6, children: _jsx(DefaultLink, { href: rssUrl, target: "_blank", children: s__('News|Continue reading in website') }) })), _jsx(AttachedFiles, {}), children] })] }), showRelatedNews && _jsx(RelatedNews, {})] }));
};
//# sourceMappingURL=Main.js.map